module.exports = __webpack_public_path__ + "img/sally_temp.2c8abab8.png";